import { Component } from '@angular/core';

@Component({
    selector: 'app-popup-content',
    templateUrl: './popup-content.component.html',
    styleUrls: ['./popup-content.component.scss'],
    standalone: false
})
export class PopupContentComponent {

}
